import { toggleMenu, toggleSearch, handleScrollHeader } from "./header";
import { scrollToHash, getSamePageAnchor } from "./smooth-scrolling";
import '../css/main.css';


document.addEventListener("DOMContentLoaded", () => {
  /**
   * Toggle del header
   */
  toggleMenu()
  toggleSearch()

  /**
   * Categories carousel import
   */
  const carousel = document.querySelectorAll(".categorias-destacadas_block");
  if (carousel.length > 0) {
    import("./carousel").then((module) => {
      carousel.forEach((slider) => {
        module.carousel(slider.querySelector('.carousel'));
      });
    });
  }

  /**
   * Image link carousel
   */
  const imageLinkCarousel = document.querySelectorAll(".imagen-con-link_block .carousel");
  if (imageLinkCarousel.length > 0) {
    import("./image-link").then((module) => {
      imageLinkCarousel.forEach((slider) => {
        module.carousel(slider);
      });
    });
  }

  /**
   * Smooth scrolling support
   */
  // If a link's href is within the current page, scroll to it instead
  document.querySelectorAll('a[href]').forEach(a => {
    a.addEventListener('click', e => {
      scrollToHash(getSamePageAnchor(a), e);
    });
  });
  // Scroll to the element in the URL's hash on load
  scrollToHash(window.location.hash);

  /**
   * ACF7 event listener
   */
  document.addEventListener('wpcf7mailsent', (event) => {
    gtag('event', 'Formulario', {
      'event_category': event.detail.contactFormId,
      'event_label': event.detail.unitTag
    });
  }, false);

  /**
   * Product video on hover
   */
  const products = document.querySelectorAll('.entry.product.type-product.content-product');
  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reducedData = window.matchMedia('(prefers-reduced-data: reduce)').matches;

  if (products.length > 0 && supportsHover && !reducedData) {
    import("./product-video").then((module) => {
      products.forEach((product) => {
        module.handleVideo(product);
      });
    });
  }

  /**
   * Single product functionality
   */
  const product = document.querySelector('.woocommerce.single-product');
  if (product) {
    handleScrollHeader();

    // Initialize sticky summary
    import('./single-product').then((module) => {
      const stickySummary = module.handleSticky(product);
      module.handleRelatedCarousel(product);
    });
  }

  /**
   * Shop page functionality
   */
  const shop = document.querySelector('.woocommerce-shop');
  if (shop) {
    handleScrollHeader();
    import("./shop").then((module) => {
      module.filterToggle();
      module.handleArchiveFilters(shop);
      module.handleFeaturedCarousel(shop);
    });
  }

  // Designer catalog
  const designerCatalog = document.querySelector('#designersCatalog');
  if (designerCatalog) {
    handleScrollHeader();
    import("./shop").then((module) => {
      module.filterToggle();
      module.handleArchiveFilters(shop);
    });
  }

  /**
   * Featured products block
   */
  const featuredProducts = document.querySelectorAll('.productos-destacados_block');
  featuredProducts.forEach((block) => {
    import("./featured-products").then((module) => {
      module.handleCarousel(block);
    });
  });

  /**
   * Accordions functionality
   */
  const accordions = document.querySelectorAll('.accordion');
  if (accordions.length > 0) {
    accordions.forEach(() => {
      import("./accordions").then((module) => {
        module.handleAccordions();
      });
    });
  }

  /**
   * Handle back to collection button
   */
  const backToCollection = document.querySelectorAll('#backToCollection');
  if (backToCollection.length > 0) {
    backToCollection.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        history.back();
      });
    });
  }
});



